"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const use_callback_ref_1 = require("use-callback-ref");
const compound_components_1 = require("@clds/compound-components");
const useMenu_1 = require("./headless/useMenu");
const useMenuState_1 = require("./headless/useMenuState");
const MenuProvider_1 = require("./MenuProvider");
/**
 * Component that manages list of items and controls navigation and focus state.
 * It doesn't control selection! This is only applicable for components that compose it
 * This component is useful when used together with other components, for example with Popover or Drawer
 */
// eslint-disable-next-line react/display-name
exports.Menu = (0, react_1.forwardRef)((_a, ref) => {
    var { children, variant, defaultFocusedId, focusedId, onFocusedIdChange, defaultSelectedId, selectedId, onSelect, maxHeight } = _a, rest = tslib_1.__rest(_a, ["children", "variant", "defaultFocusedId", "focusedId", "onFocusedIdChange", "defaultSelectedId", "selectedId", "onSelect", "maxHeight"]);
    const state = (0, useMenuState_1.useMenuState)({
        defaultFocusedId,
        focusedId,
        onFocusedIdChange,
        defaultSelectedId,
        selectedId,
        onSelect,
    });
    const menu = (0, useMenu_1.useMenu)(state);
    const mergedRef = (0, use_callback_ref_1.useMergeRefs)([menu.descendantsParentRef, ref]); // TODO maybe ref should go after state to useMenu
    return (react_1.default.createElement(MenuProvider_1.MenuProvider, Object.assign({}, menu.menuProviderProps),
        react_1.default.createElement(compound_components_1.ListStyleProvider, Object.assign({}, variant),
            react_1.default.createElement(compound_components_1.DefaultList, Object.assign({}, menu.focusableProps, { ref: mergedRef, maxHeight: maxHeight }, rest), children))));
});
//# sourceMappingURL=Menu.js.map